module.exports = __webpack_public_path__ + "static/media/singapore.5f616565.jpg";